import * as yup from 'yup';
import profileGreenIcon from 'assets/images/icons/profile-green.svg';

export const ProfileTabsList = [
  {
    id: 1,
    title: 'tabs_details',
    value: 'details',
    breadcrumbValue: { icon: profileGreenIcon, items: ['tabs_my_profile', 'tabs_details'] },
  },
  {
    id: 2,
    title: 'tabs_notifications',
    value: 'notifications',
    breadcrumbValue: { icon: profileGreenIcon, items: ['tabs_my_profile', 'tabs_notifications'] },
  },
];

export const saveProfileSchema = yup.object({
  firstName: yup.string(),
  lastName: yup.string(),
  email: yup.string().email('email must be a valid email').notRequired(),
  password: yup
    .string()
    .test(
      'password-length',
      'Password must be either empty or at least 8 characters',
      (value) => !value.length || value.length >= 8,
    ),
});
